/*
 * @Description:
 * @Date: 2021-06-21 21:59:38
 */
import store from '@/store';
import { orderManagement } from '@/api/ajax.js';
import { getTypeToString } from '@/tools';

// 获取生成中唯一缓存key
export const getCacheKey = () => store.getters['projectSettled/cacheKey'];

/**
 * @description: 设置后端勾选缓存
 * @param {array | object} rows 当前选中数据，isChecked 额外传递参数
 * @return {*}
 */
export const setCacheCheckForRows = async rows => {
  if (!rows) {
    return Promise.reject();
  }
  const arr = getTypeToString(rows) === '[object Object]' ? [rows] : rows;
  if (!arr.length) {
    return Promise.reject();
  }
  const batchJson = JSON.stringify(
    arr.map(item => {
      const isChecked = item.isChecked ? 0 : 1;
      item.isChecked = isChecked;
      return {
        isChecked,
        customizeNum: item.finishSum,
        id: item.id
      };
    })
  );
  try {
    const { pdata } = await orderManagement.isCheck({
      batchJson,
      cacheKey: getCacheKey()
    });
    // 取消勾选后重置输入数据
    if (!arr[0].isChecked) {
      const invalidationObj = pdata.invalidationObj;
      const invalidationIds = invalidationObj.map(item => item.id);
      arr.forEach(item => {
        const invalidationIndex = invalidationIds.indexOf(item.id);
        if (~invalidationIndex) {
          item._customizeNum = invalidationObj[invalidationIndex].initNum;
        }
      });
    }
    store.dispatch('projectSettled/changeInput');
    return Promise.resolve(pdata);
  } catch (e) {
    // 报错则设置为未勾选，方便table遍历取消勾选
    arr.map(item => {
      item.isChecked = 0;
    });
    return Promise.reject(e);
  }
};

// 输入框修改值同步数据
export const setCacheForInput = async row => {
  const batchJson = JSON.stringify([
    { isChecked: row.isChecked, customizeNum: row._customizeNum, id: row.id }
  ]);
  const { pdata } = await orderManagement.isCheck({
    batchJson,
    cacheKey: getCacheKey()
  });
  store.dispatch('projectSettled/changeInput');
  return Promise.resolve(pdata);
};

/**
 * @description: 全部勾选、取消
 * @param {object} query 当前搜索条件与isAll：0-取消全选 1-全选
 * @return {object}
 */
export const setAllCacheCheck = async query => {
  const { pdata } = await orderManagement.isCheck({
    ...query,
    cacheKey: getCacheKey()
  });

  store.dispatch('projectSettled/changeInput');
  return Promise.resolve(pdata);
};

// 获取当前选择数据的笔数、总金额、项目统计, 需要与isCheck同步执行
export const countSelectBill = async () => {
  const { pdata } = await orderManagement.countSelectBill({
    cacheKey: getCacheKey()
  });
  return Promise.resolve(pdata);
};

// 设置缓存后获取项目统计数据
export const combinationSetCacheChcekAndCount = async (rows, options) => {
  await setCacheCheckForRows(rows, options);
  const resp = await countSelectBill();
  return Promise.resolve(resp);
};

// 设置缓存后获取项目统计数据
export const combinationSetCacheInuputAndCount = async row => {
  await setCacheForInput(row);
  const resp = await countSelectBill();
  return Promise.resolve(resp);
};

export const getElTableComponent = children => {
  const table = children.filter(
    el => el.$options._componentTag === 'el-table'
  )[0];
  return table;
};
